/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IUserExistingModalScope extends ng.IScope {
        title: string;
        users: Models.IUser[];
        selected: {
            user: Models.IUser;
        };
        modalClose: () => void;
        modalSave: () => void;
    }

    export class UserExistingModalController {
        public static templateURL: string = "decorators/modals/user-existing-modal.html";
        public static ID: string = "#user-existing-modal";
        public static $name: string = "UserExistingModalController";
        public static $inject: string[] = ['$scope', 'close', 'title', 'users'];

        private $scope: IUserExistingModalScope;
        private close: (parameters: Models.IUser) => void;

        constructor($scope: IUserExistingModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    title: string,
                    users: Models.IUser[]) {
            this.$scope = $scope;
            this.close = close;
            this.$scope.title = title;
            this.$scope.users = users;

            this.$scope.selected = {
                user: new Models.User(),
            };

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (): void => {
                if (this.$scope.selected !== undefined && this.$scope.selected.user !== undefined &&
                    this.$scope.selected.user.id !== undefined)
                    this.close(this.$scope.selected.user);
            };
        }
    }
}
